import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AceEditorModule } from 'ng2-ace-editor';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api'; // Este es un provider, no un módulo para importar/exportar aquí
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar'; // Para 'datepicker'
import { InputTextModule } from 'primeng/inputtext'; // Para 'input'
import { InputTextareaModule } from 'primeng/inputtextarea'; // Para 'textarea'
import { DropdownModule } from 'primeng/dropdown'; // Para 'select'

import { FormFieldComponent } from './components/form-field.component';


@NgModule({
    declarations: [
        FormFieldComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RxReactiveFormsModule,
        RxReactiveDynamicFormsModule,
        BsDatepickerModule.forRoot(),
        AceEditorModule,

        FileUploadModule,
        ButtonModule,
        ToastModule,
        RadioButtonModule,
        MultiSelectModule,
        CalendarModule,
        InputTextModule,
        InputTextareaModule,
        DropdownModule
    ],
    exports: [
        FormFieldComponent,
        FileUploadModule,
        ButtonModule,
        ToastModule,
        RadioButtonModule,
        MultiSelectModule,
        CalendarModule,
        InputTextModule,
        InputTextareaModule,
        DropdownModule
    ],
    providers: [
        MessageService
    ]
})
export class FormModule { }
